import React, { Component } from 'react';
import { get } from 'lodash';

class RenderFragmentOnClient extends Component {
  componentDidMount = async () => {
    // Don't render server side or if the user is in logged out state.
    if (
      typeof window !== 'undefined' &&
      get(window, '__INITIAL_STATE__.app.fptiData.lgin', false)
    ) {
      const { insertFragment } = require('@paypalcorp/manage-client-fragment');
      const { nonce } = window.__INITIAL_STATE__;
      const name = 'quicklinks-fragment';
      const targetElement = document.getElementById('quicklinks');
      await insertFragment(name, targetElement, nonce);
    }
  };

  render() {
    return (
      <section id="quicklinks-merchanthub-container">
        <div id="quicklinks" />
      </section>
    );
  }
}

export default RenderFragmentOnClient;
